import React from 'react';
import { ChartProps, Doughnut } from 'react-chartjs-2';
import { Popup, Icon } from 'semantic-ui-react';
import { ChartData } from 'chart.js';
import { pieGraphColors } from './utils';

type PieGraphProps = Omit<ChartProps<'doughnut'>, 'data' | 'type'> & {
    title?: string;
    description?: string;
    xData: string[];
    yData: number[];
    dataLabel: string;
};

const PieGraph = (props: PieGraphProps) => {
    const { title, description, xData, yData, dataLabel, ...restProps } = props;

    const data: ChartData<'doughnut'> = {
        labels: xData,
        datasets: [
            {
                label: dataLabel,
                data: yData,
                backgroundColor: pieGraphColors,
                borderWidth: 2,
                borderColor: '#fff',
            },
        ],
    };

    return (
        <>
            <div style={{ display: 'flex', gap: 4 }}>
                {description && (
                    <Popup trigger={<Icon name="info circle" />} content={description} on="click" pinned inverted />
                )}

                {title && <h4 style={{ margin: 0 }}>{title}</h4>}
            </div>

            <Doughnut {...restProps} data={data} />
        </>
    );
};

export default PieGraph;
